import React from "react";
import {Badge} from 'reactstrap';

const SendFormatEditStatus = ({ status}) => {
    if (status === 'deployed') {
        return <Badge color="success" className="mr-1 mb-1">
            Deployed
        </Badge>
    }else if (status === 'created') {
        return <Badge color="primary" className="mr-1 mb-1">
            Requested
        </Badge>
    }else {
        return <Badge color="warning" className="mr-1 mb-1">
            {status}
        </Badge>
    }
};

export default SendFormatEditStatus;
